<template>
  <div>
    <!-- <div class="choose-box--feature">
      <div class="choose-box--feature__small">FEATURES FOR</div>
      <div class="choose-box--feature__large">
        Health Organization Administrators
      </div>
      <div class="choose-box--feature__medium">
        MyCircles builds communities to support individuals diagnosed with
        chronic conditions. Through these communities, we aim to provide
        individuals with resources and information to better manage their health
        journey. As a Healthcare Administrator, MyCircles enables your health
        system to reach those in need of the services offered by your healthcare
        team.
        <br />
        The following are the Health Organization Administrators:
      </div>

      <div class="choose-box--feature__choices dovemed-wrapper">
        <div
          class="choose-box--feature__choices--list"
          v-for="i in differentProfiles"
          :key="i"
        >
          <div class="choose-box--feature__choices--list__text">
            {{ i }}
          </div>
        </div>
      </div>
    </div> -->
    <div class="full dark-bg">
      <div class="choose-box--claimprofile dovemed-wrapper">
        <div class="choose-box--claimprofile__left">
          <div
            class="d-flex section-box mb-3 selected"
            @click="() => handleSelectProfile('0')"
          >
            <div class="box-icon white">
              <font-awesome-icon
                size="1x"
                :style="{ transform: 'scale(1.5)' }"
                :icon="['fal', 'hospital-alt']"
              />
            </div>
            <div class="d-flex flex-column">
              <div class="small">CLAIM YOUR</div>
              <div class="big">Hospital Profile</div>
            </div>
          </div>
          <div
            class="d-flex section-box mb-3"
            @click="() => handleSelectProfile('1')"
          >
            <div class="box-icon blue">
              <font-awesome-icon
                size="1x"
                :style="{ transform: 'scale(1.5)' }"
                :icon="['fal', 'clinic-medical']"
              />
            </div>
            <div class="d-flex flex-column">
              <div class="small">CLAIM YOUR</div>
              <div class="big">Clinic Profile</div>
            </div>
          </div>
          <div
            class="d-flex section-box mb-3"
            @click="() => handleSelectProfile('2')"
          >
            <div class="box-icon orange">
              <font-awesome-icon
                size="1x"
                :style="{ transform: 'scale(1.5)' }"
                :icon="['fal', 'hand-holding-heart']"
              />
            </div>
            <div class="d-flex flex-column">
              <div class="small">CLAIM YOUR</div>
              <div class="big">Non For Profit Profile</div>
            </div>
          </div>
          <div
            class="d-flex section-box mb-3"
            @click="() => handleSelectProfile('3')"
          >
            <div class="box-icon orange">
              <font-awesome-icon
                size="1x"
                :style="{ transform: 'scale(1.5)' }"
                :icon="['fal', 'hand-holding-heart']"
              />
            </div>
            <div class="d-flex flex-column">
              <div class="small">CLAIM YOUR</div>
              <div class="big">DoveBiz Profile</div>
            </div>
          </div>
        </div>
        <div class="choose-box--claimprofile__right">
          <div class="create-support__image show-class">
            <div class="create-support__image">
              <img
                alt="img"
                src="../../../../assets/images/claim-profile-right-min.png"
                class="img-src"
              />
            </div>
            <div class="create-support__description">
              <div class="create-support__description__small">WHY</div>
              <div class="create-support__description__large">
                Claim a Hospital Profile
              </div>
              <div class="create-support__description__medium">
                Once claimed, it allows for detailed listing of specialities and
                services. It also provides for listing of locations, contact
                information, and sharing of consumer and physician reviews with
                a possible 5 star rating system. Hospital Profiles can be liked,
                shared and reviewed and are verified by DoveMed.
              </div>
              <div>
                <div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['far', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Build Brand
                    </div>
                  </div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['far', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Build Book of Business
                    </div>
                  </div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['far', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Outreach to Patients and Physicians for Referrals
                    </div>
                  </div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['far', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Recruitment
                    </div>
                  </div>
                </div>
              </div>
              <a
                target="_blank"
                :href="`${SSO_BASE_URL}/ratings/hospitals/`"
                class="claim-button"
                >SEARCH HOSPITAL</a
              >
            </div>
          </div>
          <div class="create-support__image none-class">
            <div class="create-support__image">
              <img
                alt="img"
                src="../../../../assets/images/claim-profile-right-min.png"
                class="img-src"
              />
            </div>
            <div class="create-support__description">
              <div class="create-support__description__small">WHY</div>
              <div class="create-support__description__large">
                Claim a Clinic Profile
              </div>
              <div class="create-support__description__medium">
                Once claimed, it allows for detailed listing of specialities and
                services. It also provides for listing of locations, contact
                information, and sharing of consumer and physician reviews with
                a possible 5 star rating system. Clinic Profiles can be liked,
                shared and reviewed and are verified by DoveMed. The profiles
                allow for the Clinic’s to distinguish themselves from individual
                and other group practices.
              </div>
              <div>
                <div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['far', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Build Brand
                    </div>
                  </div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['fal', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Build Book of Business
                    </div>
                  </div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['far', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Outreach to Patients and Physicians for Referrals
                    </div>
                  </div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['far', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Recruitment
                    </div>
                  </div>
                </div>
              </div>
              <a
                target="_blank"
                :href="`${SSO_BASE_URL}/ratings/clinics/`"
                class="claim-button"
                >SEARCH CLINICS</a
              >
            </div>
          </div>
          <div class="create-support__image none-class">
            <div class="create-support__image">
              <img
                alt="img"
                src="../../../../assets/images/claim-profile-right-min.png"
                class="img-src"
              />
            </div>
            <div class="create-support__description">
              <div class="create-support__description__small">WHY</div>
              <div class="create-support__description__large">
                Claim a Non-For-Profits Profile
              </div>
              <div class="create-support__description__medium">
                Once claimed, it allows for detailed listing of your non for
                profit and offered resources to support your cause. It also
                provides for listing of locations, contact information, and
                sharing of updates to better engage with your donors to raise
                donor contributions. NFP Profiles can be liked, shared, promoted
                and are verified by DoveMed.
              </div>
              <div>
                <div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['far', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Promote your cause
                    </div>
                  </div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['far', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Raise donor contributions
                    </div>
                  </div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['far', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Engage with your donors
                    </div>
                  </div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['far', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Create engaged Medical Professionals
                    </div>
                  </div>
                </div>
              </div>
              <a
                target="_blank"
                :href="`${SSO_BASE_URL}/ratings/non-for-profits/`"
                class="claim-button"
              >
                SEARCH NON FOR PROFITS
              </a>
            </div>
          </div>
          <div class="create-support__image none-class">
            <div class="create-support__image">
              <img
                alt="img"
                src="../../../../assets/images/claim-profile-right-min.png"
                class="img-src"
              />
            </div>
            <div class="create-support__description">
              <div class="create-support__description__small">WHY</div>
              <div class="create-support__description__large">
                Claim a DoveBiz Profile
              </div>
              <div class="create-support__description__medium">
                Once claimed, it allows for detailed listing of business and
                offered services. It also provides for listing of locations,
                contact information, and sharing of consumer reviews with a
                possible 5 star rating system. DoveBiz Profiles can be liked,
                shared, promoted and reviewed and are verified by DoveMed.
              </div>
              <div>
                <div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['far', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Build Book of Business
                    </div>
                  </div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['far', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Engage with customers
                    </div>
                  </div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['far', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Increase revenues
                    </div>
                  </div>
                  <div class="d-flex mb-3">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        size="1x"
                        :icon="['far', 'check-circle']"
                        :style="{
                          color: '#2a71d4',
                          height: '20px',
                          width: '20px',
                        }"
                      />
                    </div>
                    <div class="create-support__description__medium--icon">
                      Increase visibility with Healthcare Professionals
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="claim-button">SEARCH DOVEBIZ</div> -->
              <a
                class="claim-button"
                :href="`${SSO_BASE_URL}/coming-soon/dovebiz/`"
                target="_blank"
                >SEARCH DOVEBIZ</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="create-support reverse">
      <div class="create-support__image">
        <img
          alt="img"
          src="../../../../assets/images/healthAd1.jpg"
          class="img-src"
        />
      </div>
      <div class="create-support__description">
        <div class="create-support__description__small">
          SHARE INFORMATION ABOUT
        </div>
        <div class="create-support__description__large">
          Healthcare Resources Provided By Your Health Organization
        </div>
        <div class="create-support__description__medium">
          Promote local physicians and services provided by your health system.
          Grow patient-intake and patient retention by reaching individuals in
          the most need of the services you provide.
        </div>
      </div>
    </div>
    <div class="full dark-bg">
      <div class="create-support dovemed-wrapper">
        <div class="create-support__image">
          <img
            alt="img"
            src="../../../../assets/images/healthAd2.jpg"
            class="img-src"
          />
        </div>
        <div class="create-support__description">
          <div class="create-support__description__small">
            SUPPORT AND ADVOCATE
          </div>
          <div class="create-support__description__large">
            Individuals Living With Chronic Conditions
          </div>
          <div class="create-support__description__medium">
            Advocate health resources in your community for individuals living
            with chronic conditions.<br />
            Build brand image and online reputation throughout communities in
            support of various chronic conditions.<br />
            Advocate Non-For-Profit mission for causes related to MyCircles
            Chronic Conditions to reach a quality audience with shared
            interests.
          </div>
        </div>
      </div>
    </div>
    <div class="create-support reverse">
      <div class="create-support__image">
        <img
          alt="img"
          src="../../../../assets/images/healthAd3.jpg"
          class="img-src"
        />
      </div>
      <div class="create-support__description">
        <div class="create-support__description__small">NETWORK WITH</div>
        <div class="create-support__description__large">
          Professionals From Healthcare Related Businesses
        </div>
        <div class="create-support__description__medium">
          Find top-talent from healthcare professionals with specialty
          expertise. Stay informed of advanced medical treatments for chronic
          conditions.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HealthCareAdmin",
  data() {
    return {
      differentProfiles: [
        "Hospital Profile Claimed Administrators",
        "Clinic Profile Claimed Administrators",
        "Non For Profits Profile Claimed Administrators",
        "DoveBiz Profile Claimed Administrators",
      ],
    };
  },
  computed: {
    SSO_BASE_URL: () => process.env.SSO_BASE_URL
  },
  methods: {
    handleSelectProfile(num) {
      const z = document.querySelector(".choose-box--claimprofile__left");
      const h = document.querySelector(".choose-box--claimprofile__right");

      let childNodes = z.children;
      let ChildNodes1 = h.children;
      for (let i = 0; i < childNodes.length; i++) {
        if (childNodes[i].classList.contains("selected")) {
          childNodes[i].classList.remove("selected");
          ChildNodes1[i].classList.remove("show-class");
          ChildNodes1[i].classList.add("none-class");
        }
      }
      childNodes[num].classList.add("selected");
      ChildNodes1[num].classList.add("show-class");
      ChildNodes1[num].classList.remove("none-class");
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/App/circle/AllCircleStaticPages/HealthCareAdmin.vue